import { Et as e, Ql as t, Z as n, Zl as r, _t as i, bt as a, ct as o, et as s, n as c, nt as l, rt as u, st as d, t as f, tt as p, wt as m, yt as h } from "./apiUrls-tIQDuFH2.js";
import "@vueuse/core";
//#region src/composables/useCoreApiService.ts
var g = () => r.getConfig().auth, _, v = (e) => {
	if (!e.token) throw Error("Token is required");
	let n = {
		auth: e.token,
		baseUrl: e.baseUrl,
		querySerializer: t()
	};
	return _ = e.baseUrl, e.locale && (n.headers = {
		...n.headers,
		"Accept-Language": e.locale
	}), r.setConfig(n), e.token;
}, y = (e) => {
	r.setConfig({ headers: {
		...r.getConfig().headers,
		"Accept-Language": e
	} });
}, b = async (e) => (await d({
	baseUrl: _,
	query: { shopId: e }
})).data.results, x = async (e) => (await h({
	baseUrl: _,
	body: e
})).data, S = async (e) => (await n({
	baseUrl: _,
	path: { ids: e.join(";") }
})).data, C = async (e) => (await o({
	baseUrl: _,
	path: { notification_group_id: e }
})).data.results, w = async (e, t) => (await m({
	baseUrl: _,
	path: {
		notification_group_id: e,
		notification_template_id: t.path.notification_template_id
	},
	body: t.body
})).data, T = async (e, t) => (await p({
	baseUrl: _,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, E = async (e, t) => (await u({
	baseUrl: _,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, D = async (e) => {
	await l({
		baseUrl: _,
		path: { notification_group_id: e }
	});
}, O = async (e) => {
	await s({
		baseUrl: _,
		path: { notification_group_id: e }
	});
}, k = async (t, n) => (await e({
	baseUrl: _,
	path: {
		notification_group_id: t,
		notification_template_id: n
	}
})).data;
function A() {
	return {
		getToken: g,
		initClient: v,
		setAcceptLanguageHeader: y,
		getNotificationGroups: b,
		postNotificationGroups: x,
		deleteNotificationGroups: S,
		getNotificationTemplates: C,
		putNotificationTemplate: w,
		disableNotificationTemplate: T,
		enableNotificationTemplate: E,
		enableAllNotificationTemplatesByGroup: D,
		disableAllNotificationTemplatesByGroup: O,
		sendTestNotification: k
	};
}
//#endregion
//#region src/composables/useShipmentCapabilitiesService.ts
var j = () => r.getConfig().auth, M = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let n = {
		baseUrl: c,
		auth: e.token,
		querySerializer: t(),
		headers: { Accept: "application/json;charset=utf-8;version=2.0" }
	};
	return e.environment && e.environment === "acceptance" && (n.baseUrl = f), e.locale && (n.headers = {
		...n.headers,
		"Accept-Language": e.locale
	}), r.setConfig(n), e.token;
}, N = (e) => {
	r.setConfig({ headers: {
		...r.getConfig().headers,
		"Accept-Language": e
	} });
}, P = async (e) => (await i({ body: e })).data.results;
function F() {
	return {
		getToken: j,
		initClient: M,
		setAcceptLanguageHeader: N,
		postShipmentsCapabilities: P
	};
}
//#endregion
//#region src/composables/useShipmentPricingService.ts
var I = () => r.getConfig().auth, L = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let n = {
		baseUrl: c,
		auth: e.token,
		querySerializer: t(),
		headers: { Accept: "application/json;charset=utf-8;version=2.0" }
	};
	return e.environment && e.environment === "acceptance" && (n.baseUrl = f), e.locale && (n.headers = {
		...n.headers,
		"Accept-Language": e.locale
	}), r.setConfig(n), e.token;
}, R = (e) => {
	r.setConfig({ headers: {
		...r.getConfig().headers,
		"Accept-Language": e
	} });
}, z = async (e) => (await a({ body: e })).data ?? null;
function B() {
	return {
		getToken: I,
		initClient: L,
		setAcceptLanguageHeader: R,
		postShipmentsRates: z
	};
}
//#endregion
export { F as n, A as r, B as t };
